import {BASE_URL} from '../config'
import {APIRequestOptions, RequestParams} from '../interfaces'
import {APIRequestResource} from '../types'

export const generateUrl = (reqResource: APIRequestResource, { id, resource, endpoint, suffix, baseURL }: APIRequestOptions) => {
  return [baseURL ?? BASE_URL, resource ?? reqResource, id, endpoint, suffix]
    .filter((x) => !!x)
    .join('/')
    .split('://')
    .map((p) => p.replace(/\/\//, '/'))
    .join('://')
}

export const generateParams = (
  params: RequestParams
): Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>> => {
  const newParams: Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>> = {}

  if (params.limit) {
    newParams['limit'] = params.limit
  }

  if (params.offset) {
    newParams['offset'] = params.offset
  }

  if (params.search_term) {
    newParams['search_term'] = params.search_term
  }

  // if (params.multi_sort_meta) {
  //   for (let i = 0; i < params.multi_sort_meta.length; i++) {
  //     const sort = params.multi_sort_meta[i]
  //     newParams[`multi_sort_meta[${i}][field]`] = sort.field
  //     newParams[`multi_sort_meta[${i}][order]`] = sort.order
  //   }
  // }

  return newParams
}
